/** @jsxImportSource react */
//import { Link } from "@tanstack/react-router";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";

type Video = {
  title: string;
  url: string;
  img: string;
};

interface MediaPlayerProps {
  embedURL: string;
  videos: Video[];
}

const defaultVideos: Video[] = [];

export function MediaPlayer({
  embedURL,
  videos = defaultVideos,
}: MediaPlayerProps) {
  return (
    <div className="w-full px-2 sm:p-4">
      <div className="relative flex flex-wrap overflow-hidden rounded-lg border border-border shadow-lg">
        {/* Video section */}
        <div className="relative z-20 w-full bg-background lg:min-w-[50%] lg:flex-1">
          <div className="relative w-full bg-[#000] pb-[56.25%]">
            <iframe
              className="absolute left-0 top-0 h-full w-full rounded-md"
              src={embedURL}
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
              title="Video Player"
            />
          </div>
        </div>

        {/* Navigation section */}
        <aside className="relative z-10 w-full lg:w-80">
          <ScrollArea className="h-[60vh] min-h-40 lg:h-[calc(100vh-2rem)]">
            <nav className="pr-4" aria-label="Videos" id="video-nav">
              <ul className="divide-y divide-border">
                {videos.map((video) => (
                  <li key={video.url}>
                    <a
                      href={video.url}
                      className={cn(
                        "flex items-start gap-2 p-1",
                        "transition-colors hover:bg-muted/50",
                        "text-foreground no-underline"
                      )}
                    >
                      <div className="relative w-32 flex-none sm:w-40">
                        <div className="pb-[56.25%]">
                          <img
                            src={video.img}
                            alt=""
                            className="absolute left-0 top-0 h-full w-full rounded-sm object-cover"
                          />
                        </div>
                      </div>
                      <span className="py-1 text-sm font-medium leading-tight">
                        {video.title}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </ScrollArea>
        </aside>
      </div>
    </div>
  );
}

export const videos = [
  {
    title: "Slimpro6 and The Bobbettes 17/04/10 (1/4)",
    url: "/music/bobettes",
    img: "/images/thumbnails/bobettes.jpg",
  },
  {
    title: "Slimpro6 & the Bobbettes 25/03/09",
    url: "/music/bobettes-2",
    img: "/images/thumbnails/bobettes-2.jpg",
  },
  {
    title: "Noise",
    url: "/music/noise",
    img: "/images/thumbnails/noise.jpg",
  },
  {
    title: "RITZUN RATZUN ROTZER - On me 'ead",
    url: "/music/ritzun",
    img: "/images/thumbnails/ritzun.jpeg",
  },
  {
    title: "Noodleman",
    url: "/music/noodleman",
    img: "/images/thumbnails/noodleman.jpeg",
  },
  {
    title: "Ritsun Ratzun Rotzer - It's hard to be old", // when your parents are young
    url: "/music/ritzun-hard",
    img: "/images/thumbnails/hard.jpeg",
  },
  {
    title: "Support for Marc Riley + The Creepers",
    url: "/music/creepers",
    img: "/images/thumbnails/creepers.jpeg",
  },
  {
    title: "Biscuit Badger - The Seaweed Under the Sofa",
    url: "/music/seaweed",
    img: "/images/thumbnails/seaweed.jpeg",
  },
];
